<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('GlobalSetObj.tips')"
    :visible.sync="tipDialog"
    width="550px"
  >
    <div v-if="Object.keys(filteredResult).length !== 0">
      {{ $t('receivablePayable.ReasonForFailure') }}
    </div>
    <div class="wrapDialog">
      <!-- 过滤：只显示 code !== 200 的数据 -->
      <div v-for="(value, key) in filteredResult" :key="key" class="order-item">
        <span class="order-no" style="margin-right: 5px">{{ key }}:</span>
        <span class="order-msg">{{ value.msg }}</span>
      </div>

      <!-- 无失败数据时显示 -->
      <div v-if="Object.keys(filteredResult).length === 0" class="success-tip">
        {{ $t('receivablePayable.allExecutionSuccess') }}
      </div>
    </div>

    <div slot="footer" class="dialog-footer" style="text-align: center">
      <el-button size="small" type="primary" @click="tipDialog = false">
        {{ $t('GlobalSetObj.Close') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      tipDialog: false,
      resultObj: {}
    };
  },
  computed: {
    // 计算属性：过滤掉 code = 200 的成功数据
    filteredResult() {
      const filtered = {};
      Object.keys(this.resultObj).forEach((key) => {
        const item = this.resultObj[key];
        // 只保留 code 不是 200 的失败项
        if (item.code !== 200) {
          filtered[key] = item;
        }
      });
      return filtered;
    }
  },
  methods: {
    showTip(data) {
      this.resultObj = data;
      this.tipDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapDialog {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;

  .order-item {
    padding: 5px;
    border-radius: 4px;
    line-height: 1;
    display: flex;
    align-items: center;

    .order-no {
      color: #333;
      min-width: 180px;
    }

    .order-msg {
      font-size: 12px;
      color: #f56c6c;
      flex: 1;
    }
  }

  .success-tip {
    text-align: center;
    padding: 30px 20px;
    font-size: 18px;
    font-weight: bold;
    color: #00b42a;
    letter-spacing: 2px;
  }
}
</style>
